import React from 'react';
import { logErrorToConsole } from 'src/utils/util';
import {
    StyledTabContentContianer,
    TabContent,
    TabContentFont,
    TabSelectedBorder,
} from './adminNameDetailTab.styled';

const AdminNameDetailTabList = ({ label, isTabActive, tabSwitch, id }) => {
    return (
        <>
            <StyledTabContentContianer
                id="admin-nameDetails-tab"
                onClick={() => {
                    try {
                        tabSwitch(id);
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                isSelected={isTabActive}
                cursor={'pointer'}
            >
                <TabContent isPending={false} isBatch={false}>
                    <TabContentFont isSelected={isTabActive}>
                        {label}
                    </TabContentFont>
                </TabContent>
                <TabSelectedBorder isSelected={isTabActive} />
            </StyledTabContentContianer>
        </>
    );
};

export default AdminNameDetailTabList;
